import { COLORS, TYPE, SPACE } from './tokens'
import SectionLabel from './SectionLabel'

const DANGER = '#C04A3D'

function StageChip({ state, index }) {
  const isDone = state === 'done'
  const isFailed = state === 'failed'
  const bg = isDone ? COLORS.accent : isFailed ? DANGER : COLORS.bodyBg
  const color = isDone || isFailed ? COLORS.panelBg : COLORS.mutedText
  return (
    <div style={{
      width: '36px', height: '36px', borderRadius: '50%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: bg,
      border: `1.5px solid ${isDone ? COLORS.accent : isFailed ? DANGER : COLORS.hairline}`,
      color, fontWeight: 600, fontSize: '14px'
    }}>
      {isDone ? '✓' : isFailed ? '✗' : String(index)}
    </div>
  )
}

export default function PipelineFailureState({ stages, error, onRetry, onStartOver }) {
  const { advisorText, internalCode, httpStatus, stage } = error || {}
  const failedStageName = stage === 'analyst' ? 'Analyst' : stage === 'specialist' ? 'Specialist' : stage === 'qa' ? 'QA' : 'Pipeline'

  return (
    <section style={{ maxWidth: SPACE.sectionMaxWidth, margin: '0 auto', padding: `48px ${SPACE.pagePadding}` }}>
      <SectionLabel>Review did not complete</SectionLabel>

      <div style={{ position: 'relative', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', alignItems: 'center', margin: '32px 0' }}>
        <div style={{ position: 'absolute', top: '50%', left: '5%', right: '5%', height: '1px', background: COLORS.hairline }} />
        <div style={{ display: 'flex', justifyContent: 'center', zIndex: 2 }}><StageChip state={stages.analyst} index={1} /></div>
        <div style={{ display: 'flex', justifyContent: 'center', zIndex: 2 }}><StageChip state={stages.specialist} index={2} /></div>
        <div style={{ display: 'flex', justifyContent: 'center', zIndex: 2 }}><StageChip state={stages.qa} index={3} /></div>
      </div>

      <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
        <li style={{ padding: '12px 0' }}>
          <div style={{ ...TYPE.smallCaps, color: stages.analyst === 'done' ? COLORS.bodyText : COLORS.mutedText }}>Analyst</div>
          <div style={{ ...TYPE.body, color: COLORS.mutedText, marginTop: '2px' }}>
            {stages.analyst === 'done' ? 'Extracted policy structure' : 'Not run'}
          </div>
        </li>
        <li style={{ padding: '12px 0' }}>
          <div style={{ ...TYPE.smallCaps, color: stages.specialist === 'done' || stages.specialist === 'failed' ? COLORS.bodyText : COLORS.mutedText }}>Specialist</div>
          <div style={{ ...TYPE.body, color: stages.specialist === 'failed' ? DANGER : COLORS.mutedText, marginTop: '2px' }}>
            {stages.specialist === 'failed' ? advisorText || 'Failed' : stages.specialist === 'done' ? 'Analyzed coverage adequacy' : 'Not run'}
          </div>
          {stages.specialist === 'failed' && internalCode && (
            <div style={{ ...TYPE.supporting, color: COLORS.mutedText, marginTop: '4px', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>
              HTTP {httpStatus} · {internalCode}
            </div>
          )}
        </li>
        <li style={{ padding: '12px 0' }}>
          <div style={{ ...TYPE.smallCaps, color: stages.qa === 'done' || stages.qa === 'failed' ? COLORS.bodyText : COLORS.mutedText }}>QA</div>
          <div style={{ ...TYPE.body, color: stages.qa === 'failed' ? DANGER : COLORS.mutedText, marginTop: '2px' }}>
            {stages.qa === 'failed' ? advisorText || 'Failed' : stages.qa === 'done' ? 'Verified citations and voice' : 'Skipped'}
          </div>
          {stages.qa === 'failed' && internalCode && (
            <div style={{ ...TYPE.supporting, color: COLORS.mutedText, marginTop: '4px', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>
              HTTP {httpStatus} · {internalCode}
            </div>
          )}
        </li>
      </ul>

      <div style={{ display: 'flex', gap: '12px', marginTop: '32px' }}>
        <button
          onClick={onRetry}
          style={{
            ...TYPE.body,
            padding: '10px 20px',
            background: COLORS.accent,
            color: COLORS.retentionBg,
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Retry {failedStageName} and downstream stages
        </button>
        <button
          onClick={onStartOver}
          style={{
            ...TYPE.body,
            padding: '10px 20px',
            background: 'transparent',
            color: COLORS.bodyText,
            border: `1px solid ${COLORS.hairline}`,
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Start over
        </button>
      </div>

      <p style={{ ...TYPE.supporting, color: COLORS.mutedText, marginTop: '20px', fontStyle: 'italic' }}>
        Analyst output has been preserved. Reference code <code style={{ background: COLORS.panelBg, border: `1px solid ${COLORS.hairline}`, padding: '1px 6px', borderRadius: '3px', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>{internalCode}</code>
        {' '}· firm administrators can review the full audit trail from the Global Admin panel.
      </p>
    </section>
  )
}
